import Product from "features/Product/ProductList/Product";

const ProductPage: React.FC = () => {
  return <Product />;
};

export default ProductPage;
